import Highcharts from 'highcharts';
import { jwtDecode } from 'jwt-decode';
import { odsToastNotification } from 'kfone-component-library';
import { ToastNotificationPosition } from 'kfone-component-library/enums';
import { ToastNotificationProps } from 'kfone-component-library/types';
import { ChartColors, ReportDetails } from 'model/constants';
import {
  AllPayGapsState,
  CategoryDataState,
  PayByGroupState,
  TopGapInsightsState,
} from 'model/types';

const chartDefaultColors = Highcharts.defaultOptions.colors;

export const classNames = (...classes: any[]): string => {
  return classes?.length ? classes.filter(Boolean).join(' ') : '';
};

//Type Guard Function
export const isString = (value: any): value is string => typeof value === 'string';

export const getUserName = (keycloakAuthState: any): string => {
  if (keycloakAuthState?.token) {
    const decodedToken: any = jwtDecode(String(keycloakAuthState?.token));
    const userName = (decodedToken?.idTokenParsed?.name as string) ?? '';

    return userName;
  }
  return '';
};
export const getTimeStamp = (dateInput = new Date()) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export const sortByDemographicText = (
  a: AllPayGapsState | TopGapInsightsState | PayByGroupState | CategoryDataState,
  b: AllPayGapsState | TopGapInsightsState | PayByGroupState | CategoryDataState,
) => {
  const nameA = a.demoGroupValue.toUpperCase(); // ignore upper and lowercase
  const nameB = b.demoGroupValue.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  // names must be equal
  return 0;
};
export const sortByGraphCategoryValue = (
  a: AllPayGapsState | TopGapInsightsState | PayByGroupState | CategoryDataState,
  b: AllPayGapsState | TopGapInsightsState | PayByGroupState | CategoryDataState,
) => {
  const nameA = Number(a?.graphCategoryVal);
  const nameB = Number(b?.graphCategoryVal);
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  // names must be equal
  return 0;
};

export const sortByCategoryValue = (a: string, b: string) => {
  const valA = Number(a);
  const valB = Number(b);
  if (!isNaN(valA) && !isNaN(valB)) {
    return valA - valB;
  }
  return a.localeCompare(b);
};

export const getChartColorsByDemographic = (demographyName = '') => {
  if (demographyName === ReportDetails.genderLabel) {
    return [
      ChartColors.GENDER_CHART.MALE,
      ChartColors.GENDER_CHART.FEMALE,
      ChartColors.GENDER_CHART.OHTER,
      ...(chartDefaultColors ?? []),
    ];
  } else if (demographyName === ReportDetails.raceLabel) {
    return [
      ChartColors.RACE_ETHNICITY_CHART.WHITE,
      ChartColors.RACE_ETHNICITY_CHART.BLACK,
      ChartColors.RACE_ETHNICITY_CHART.HISPANIC,
      ChartColors.RACE_ETHNICITY_CHART.ASIAN,
      ChartColors.RACE_ETHNICITY_CHART.OTHER,
      ChartColors.RACE_ETHNICITY_CHART.MORE,
      ...(chartDefaultColors ?? []),
    ];
  } else {
    return [
      ChartColors.GENDER_CHART.MALE,
      ChartColors.GENDER_CHART.FEMALE,
      ChartColors.GENDER_CHART.OHTER,
      ChartColors.RACE_ETHNICITY_CHART.WHITE,
      ChartColors.RACE_ETHNICITY_CHART.BLACK,
      ChartColors.RACE_ETHNICITY_CHART.HISPANIC,
      ChartColors.RACE_ETHNICITY_CHART.ASIAN,
      ChartColors.RACE_ETHNICITY_CHART.OTHER,
      ChartColors.RACE_ETHNICITY_CHART.MORE,
      ...(chartDefaultColors ?? []),
    ];
  }
};


export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value?.split(`; ${name}=`);
  if (parts?.length === 2) return parts?.pop()?.split(';')?.shift() ?? null;
  return null;
};

export const showToastNotification = (notificationProps: ToastNotificationProps) => {
  const props = {
    ...notificationProps,
    options: {
      toastId: 'payequity-global-toast',
      closeButton: true,
      autoClose: 3000,
      position: ToastNotificationPosition.TopRight,
      ...(notificationProps.options ?? {}),
    },
  };
  odsToastNotification(props);
};
